import styled from 'styled-components';

export const ButtonLayout = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`;
